export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14350.c73f28d1.jpg";